import Fetch from '../utils/httpHelper'
import Cookies from 'js-cookie'
import {AUTH_TOKEN_COOKIE_KEY} from '../constants'

const API_URL = process.env.REACT_APP_FLEKSUP_API_URL

const servicePaths = {
  getSettingsByType: '/api/settings',
  updateSettings: '/api/settings',
  updateConnectionSettings: '/api/settings/connection-setting-update',
  getSettingsByKeyList: '/api/settings/setting-keys',
  eCommerceTest: '/api/APIConnection/ecommerce',
  erpTest: '/api/APIConnection/erp',
  getJobHistories: '/api/JobHistory',
  doLongPollingJobHistories: '/api/JobHistory/do-long-polling',
  getJobErrorReports: '/api/JobErrorReport',
  getAccount: '/api/Account',
  updateAccount: '/api/Account',
  getJobsByTypes: '/api/Job/type-filter',
  updateJob: '/api/job',
  runJob: '/api/Job/run-job',
  getLicence: '/api/CustomerLicense',
  updateCompany: '/api/Account/company',
  recoverPassword: '/api/account/recover-password',
  checkRowId: '/api/account/check-row-id',
  resetPassword: '/api/account/reset-password',
  getActivities: '/api/Activity',
  getNotifications: '/api/Notification',
  unreadNotificationsCount: '/api/Notification/count',
  markAsRead: '/api/Notification/mark-as-read',
  updatePassword: '/api/Account/update-password',
  getJobById: '/api/Job',
  getSalesReport: '/api/SalesReport',
  getJobHistoryReport: '/api/JobHistory/report',
  getDashboard: '/api/Dashboard',
  getDashboardSalesReports: '/api/Dashboard/sales-reports',
  getErpMatching: '/api/ErpMatching',
  createErpMatching: '/api/ErpMatching',
  deleteMatching: '/api/ErpMatching',
  getPaymentList: '/api/Settings/ecommerce-payment-type-list',
  createTicket: '/api/Ticket/my-company',
  getCategories: '/api/Ticket/categories',
  getTicketList: '/api/Ticket/my-company',
  getTicketById: '/api/Ticket/my-company',
  replyTicket: '/api/Ticket/my-company/ticket_reply',
  closeTicket: '/api/Ticket/my-company/update-state',
  getOrderStates: '/api/settings/ecommerce-order-status-list',
  getTicketCountByStatus:'/api/Ticket/count-by-status',
  getErpPriceGroups: '/api/settings/erp-price-group-list',
  getEcommercePriceGroups: '/api/settings/ecommerce-price-group-list',
  getSalesChannels: '/api/settings/sales-channel-list',
  getSettingsLayout: '/api/settings/settings-layout',
  getErpCustomSettingsByKey: 'api/settings/custom-data',
  getEcommerceCustomSettingsByKey: 'api/settings/e-commerce/custom-data',
  addActivity: '/api/activity',
}

const fetcher = new Fetch(
  {
    baseURL: API_URL,
  },
  function(config) {
    config.headers.Authorization = `Bearer ${Cookies.get(AUTH_TOKEN_COOKIE_KEY)}`
    return config
  },
)

export const FleksupService = {
  sendSSORequestToLogo,
  getUserAppKeyFromLogo,
  integrationLoginToLogo,
  getSettingsByType,
  updateSettings,
  getSettingsByKeyList,
  eCommerceTest,
  erpTest,
  getJobHistories,
  doLongPollingJobHistory,
  getJobErrorReports,
  getAccount,
  updateAccount,
  getJobsByTypes,
  updateJob,
  runJob,
  getLicence,
  updateCompany,
  recoverPassword,
  checkRowId,
  resetPassword,
  getActivities,
  getNotifications,
  getUnreadNotificationsCount,
  markAsRead,
  updatePassword,
  getJobById,
  getSalesReport,
  getJobHistoryReportById,
  getDashboard,
  getDashboardSalesReports,
  getErpMatching,
  createErpMatching,
  deleteMatching,
  getPaymentList,
  createTicket,
  getCategories,
  getTicketList,
  getTicketCountByStatus,
  getTicketById,
  replyTicket,
  closeTicket,
  getOrderStates,
  getPriceGroups,
  getSalesChannels,
  getSettingsLayout,
  getCustomSettingByKey,
  getByPath,
  removeHistories,
  addActivity,
  finishPendingRequests,
  GetStockLocations,
  GetCustomData
}

function getSalesChannels() {
  let path = `${servicePaths.getSalesChannels}`

  return fetcher.get({
    url: path,
  })
}
function GetStockLocations(stockLocationPlatformType = 'erp'){

  const apiPathPrefix = stockLocationPlatformType ==='erp' ? servicePaths.getErpCustomSettingsByKey : servicePaths.getEcommerceCustomSettingsByKey;


  let path = `${apiPathPrefix}/depo-list`

  return fetcher.get({
    url: path,
  })
}

function GetCustomData(platformType:string,dataKey:string){
  const apiPathPrefix = platformType ==='erp' ? servicePaths.getErpCustomSettingsByKey : servicePaths.getEcommerceCustomSettingsByKey;

  let path = `${apiPathPrefix}/${dataKey}`;

  return fetcher.get({
    url: path,
  })
}



function getPriceGroups(priceGroupType: string = 'erp') {

  let path = `${servicePaths.getErpPriceGroups}`
  if(priceGroupType!=="erp"){
    path = `${servicePaths.getEcommercePriceGroups}`
  }

  return fetcher.get({
    url: path,
  })
}

function getCustomSettingByKey(settingKey: string) {
  let path = `${servicePaths.getErpCustomSettingsByKey}/${settingKey}`

  return fetcher.get({
    url: path,
  })
}

function getSettingsByType(settingType: string) {
  let path = `${servicePaths.getSettingsByType}/${settingType}`

  return fetcher.get({
    url: path,
  })
}

function updateSettings(data: any, isConnectionSetting: boolean = false, connectionInfo: any = null) {
  let path = `${servicePaths.updateSettings}`
  if (isConnectionSetting && connectionInfo) {
    path = `${servicePaths.updateConnectionSettings}/${connectionInfo.connectionType}/${connectionInfo.productType}`
  }
  return fetcher.post({
    url: path,
    data: data,
  })
}

function getSettingsByKeyList(keyList: any) {
  let path = `${servicePaths.getSettingsByKeyList}/${keyList}`
  return fetcher.get({
    url: path,
  })
}


function sendSSORequestToLogo(webserviceURL:string,apiKey:string) {
  let path = webserviceURL;
  return fetcher.get({
    url: path,
    config: {
    headers: {
      'apiKey':apiKey,
      'Content-Type': 'application/json'
    }
  }})
}


function getUserAppKeyFromLogo(webserviceURL:string,apiKey:string,code:string) {
  return fetcher.post({
    url: webserviceURL,
    data: {
      key : code
    },
    config: {
      headers: {
        'apiKey':apiKey,
        'Content-Type': 'application/json'
      }
    }})
}

function integrationLoginToLogo(webserviceURL:string,apiKey:string,data:any) {
  return fetcher.post({
    url: webserviceURL,
    data: data,
    config: {
      headers: {
        'apiKey':apiKey,
        'Content-Type': 'application/json'
      }
    }})
}

function eCommerceTest(ecommerceType: any) {
  let path = `${servicePaths.eCommerceTest}/${ecommerceType}`
  return fetcher.post({
    url: path,
  })
}

function erpTest(erpType: any) {
  let path = `${servicePaths.erpTest}/${erpType}`
  return fetcher.post({
    url: path,
  })
}

function getJobHistories(filters: any) {
  let path = `${servicePaths.getJobHistories}`
  if (filters.jobTypes) {
    path += `?jobTypes=${filters.jobTypes}`
  }
  if (filters.startDate && filters.endDate) {
    path += `&startDate=${filters.startDate}`
    path += `&endDate=${filters.endDate}`
  }
  if (filters.pageNumber) {
    path += `&pageNumber=${filters.pageNumber}`
  }
  if (filters.pageSize) {
    path += `&pageSize=${filters.pageSize}`
  }
  return fetcher.get({
    url: path,
  })
}

function doLongPollingJobHistory(channelName: string, filters: any) {
  let path = `${servicePaths.doLongPollingJobHistories}`
  if (filters.jobTypes) {
    path += `?jobTypes=${filters.jobTypes}&channelName=${channelName}`
  }

  return fetcher.get({
    url: path,
  }, true)
}


function getJobErrorReports(filters: any) {
  let path = `${servicePaths.getJobErrorReports}/${filters.pageNumber}/${filters.pageSize}/${filters.jobType}?`
  path += `searchText=${filters.searchText}`
  if (filters.status) {
    path += `&status=${filters.status === 'true'}`
  }
  if (filters.errorType) {
    path += `&errorType=${filters.errorType}`
  }
  return fetcher.get({
    url: path,
  })
}

function getAccount() {
  return fetcher.get({
    url: `${servicePaths.getAccount}`,
  })
}

function updateAccount(data: any) {
  return fetcher.put({
    url: `${servicePaths.updateAccount}`,
    data: data,
  })
}

function getJobsByTypes(types: string) {
  return fetcher.get({
    url: `${servicePaths.getJobsByTypes}/${types}`,
  })
}

function updateJob(job: any) {
  return fetcher.put({
    url: `${servicePaths.updateJob}`,
    data: job,
  })
}

function runJob(jobId: any) {
  let path = `${servicePaths.runJob}?jobId=${jobId}`
  return fetcher.post({
    url: path,
  })
}

function getLicence() {
  return fetcher.get({
    url: `${servicePaths.getLicence}`,
  })
}

function updateCompany(company: any) {
  return fetcher.put({
    url: `${servicePaths.updateCompany}`,
    data: company,
  })
}

function recoverPassword(email: any) {
  return fetcher.post({
    url: `${servicePaths.recoverPassword}?email=${email}`,
  })
}

function checkRowId(rowId: any) {
  return fetcher.post({
    url: `${servicePaths.checkRowId}?rowid=${rowId}`,
  })
}

function resetPassword(rowId: any, password: any, confirmPassword: any) {
  return fetcher.post({
    url: `${servicePaths.resetPassword}?rowId=${rowId}&password=${password}&confirmPassword=${confirmPassword}`,
  })
}

function getActivities(pageNumber: number, pageSize: number) {
  return fetcher.get({
    url: `${servicePaths.getActivities}/${pageNumber}/${pageSize}`,
  })
}

function getNotifications(pageNumber: number, pageSize: number) {
  return fetcher.get({
    url: `${servicePaths.getNotifications}/${pageNumber}/${pageSize}`,
  })
}

function getUnreadNotificationsCount() {
  return fetcher.get({
    url: `${servicePaths.unreadNotificationsCount}`,
  })
}

function markAsRead(idList: any) {
  return fetcher.post({
    url: `${servicePaths.markAsRead}`,
    data: idList,
  })
}

function updatePassword(oldPassword: any, password: any, confirmPassword: any) {
  return fetcher.post({
    url: `${servicePaths.updatePassword}?oldPassword=${oldPassword}&password=${password}&confirmPassword=${confirmPassword}`,
  })
}

function getJobById(jobId: any) {
  return fetcher.get({
    url: `${servicePaths.getJobById}/${jobId}`,
  })
}

function getSalesReport(filters: any) {
  let path = `${servicePaths.getSalesReport}`

  if (filters.pageNumber) {
    path += `?pageNumber=${filters.pageNumber}`
  }
  if (filters.pageSize) {
    path += `&pageSize=${filters.pageSize}`
  }
  if (filters.startDate && filters.endDate) {
    path += `&startDate=${filters.startDate}`
    path += `&endDate=${filters.endDate}`
  }
  return fetcher.get({
    url: path,
  })
}

function getJobHistoryReportById(jobHistoryId: number) {
  return fetcher.get({
    url: `${servicePaths.getJobHistoryReport}/${jobHistoryId}`,
  })
}

function getDashboard() {
  return fetcher.get({
    url: `${servicePaths.getDashboard}`,
  })
}

function getDashboardSalesReports(timePeriod: string) {
  return fetcher.get({
    url: `${servicePaths.getDashboardSalesReports}?timePeriod=${timePeriod}`,
  })
}

function getErpMatching(matchingType: string) {
  return fetcher.get({
    url: `${servicePaths.getErpMatching}/${matchingType}`,
  })
}

function createErpMatching(data: any) {
  return fetcher.post({
    url: `${servicePaths.createErpMatching}`,
    data: data,
  })
}

function deleteMatching(id: any) {
  return fetcher.delete({
    url: `${servicePaths.deleteMatching}/${id}`,
  })
}

function getPaymentList() {
  return fetcher.get({
    url: `${servicePaths.getPaymentList}`,
  })
}

function createTicket(data: any) {
  return fetcher.post({
    url: `${servicePaths.createTicket}`,
    data: data,
  })
}

function getCategories(parentId: any = undefined) {
  let path = `${servicePaths.getCategories}`

  if (parentId) {
    path = path + `?parentid=${parentId}`
  }

  return fetcher.get({
    url: path,
  })
}

function getTicketList(filters: any) {
  let path = `${servicePaths.getTicketList}/${filters.pageNumber}/${filters.pageSize}?orderBy=${filters.orderBy}`

  if (filters.searchTerm && filters.searchTerm !== '') {
    path += `&searchKey=${filters.searchTerm}`
  }

  if (filters.status && filters.status !== '') {
    path += `&status=${filters.status}`
  }
  return fetcher.get({
    url: path,
  })
}


function getTicketCountByStatus(status:number) {
  return fetcher.get({
    url: `${servicePaths.getTicketCountByStatus}/${status}`,
  })
}
function getOrderStates() {
  return fetcher.get({
    url: `${servicePaths.getOrderStates}`,
  })
}

function getTicketById(ticketId: any) {
  return fetcher.get({
    url: `${servicePaths.getTicketById}/${ticketId}`,
  })
}

function replyTicket(data: any) {
  return fetcher.post({
    url: `${servicePaths.replyTicket}`,
    data: data
  })
}


function closeTicket(ticketId: number) {
  return fetcher.post({
    url: `${servicePaths.closeTicket}?ticketid=${ticketId}&status=3`,
  });
}

function getSettingsLayout() {
  let path = `${servicePaths.getSettingsLayout}`

  return fetcher.get({
    url: path,
  })
}

function getByPath(path: string) {
  return fetcher.get({
    url: path,
  })
}

function removeHistories(idList: any) {
  return fetcher.post({
    url: '/api/JobErrorReport/delete',
    data: {
      jobErrorIdList: idList,
    },
  })
}

function addActivity(data: any) {
  return fetcher.post({
    url: `${servicePaths.addActivity}`,
    data: data,
  })
}

function finishPendingRequests(reason: string) {
  fetcher.finishPendingRequests(reason)
}
